// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-styles-icons-___callIcon__nudge_1___VVxgh{position:relative;top:1px;right:1px}.app-styles-icons-___callIcon__nudge_2___tmD9c{position:relative;top:2px;right:2px}`, "",{"version":3,"sources":["webpack://./app/styles/icons/callIcon.scss"],"names":[],"mappings":"AAAA,+CACE,iBAAA,CACA,OAAA,CACA,SAAA,CAGF,+CACE,iBAAA,CACA,OAAA,CACA,SAAA","sourcesContent":[".nudge_1 {\n  position: relative;\n  top: 1px;\n  right: 1px;\n}\n\n.nudge_2 {\n  position: relative;\n  top: 2px;\n  right: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nudge_1": `app-styles-icons-___callIcon__nudge_1___VVxgh`,
	"nudge_2": `app-styles-icons-___callIcon__nudge_2___tmD9c`
};
export default ___CSS_LOADER_EXPORT___;
